module.exports = __webpack_public_path__ + "5da2569bd2f3aabb605313c5de9be8e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-11.png
// module id = 2070
// module chunks = 0